export const convertTo12HourFormat = (time24: string) => {
    const [hours, minutes] = time24.split(':');
    let period = 'AM';
    let hours12 = parseInt(hours, 10);

    if (hours12 >= 12) {
        period = 'PM';
        if (hours12 > 12) {
            hours12 -= 12;
        }
    }

    if (hours12 === 0) {
        hours12 = 12;
    }

    return `${hours12.toString().padStart(2, '0')}:${minutes} ${period}`;
};
